import type { CalendarRequest } from "src/core/backend/clients/backendClient";
import { backendService } from "src/core/backend/services/backendService";

class CalendarService {
  public calendarSlots(request: CalendarRequest) {
    return backendService.createBackendClient().apiCalendar(request);
  }
}

export const calendarService = new CalendarService();
